
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./LoginApp": () => {
return Promise.all(/*  | __federation_expose_LoginApp */ [__webpack_require__.e("4075"), __webpack_require__.e("5021")]).then(() => (() => (__webpack_require__(1577))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };